export default __webpack_public_path__ + "static/media/yourinformations.653b7622.svg";